import { ProfileProvider } from "../profileProvider/ProfileProvider";

// ProfileData interface-i burada birbaşa təyin olunur
interface ProfileData {
  name: string;
  surname: string;
  email: string;
  number: string;
  address: string;
  fin: string;
  password: string;
  new_password: string;
  confirm_password: string;
  number_prefix: string;
}

export default class ProfileServices {
  // Profil məlumatlarını əldə etmək
  static async ProfileData() {
    try {
      const res = await ProfileProvider.getProfileData();
      console.log(res.data,'response');
       // Profil məlumatlarını alırıq
      if (res.data) localStorage.setItem("name", res.data.name);
      return res.data; // Gələn məlumatları geri qaytarırıq
    } catch (error) {
      console.error("Profil məlumatları alınarkən səhv baş verdi:", error);
      throw error; // Xətanı atırıq
    }
  }

  static async UpdateProfile(data: ProfileData) {
    try {
      const res = await ProfileProvider.updateProfile(data);
      return res.data;
    } catch (error) {
      console.error("Profil məlumatları yenilənərkən səhv baş verdi:", error);
      throw error;
    }
  }
}
